<template>
<div class="row">
    <div class="col-6 col-md-2">
        <summary-block :site_id="site_id" range="Today"></summary-block>
    </div>
    <div class="col-6 col-md-2">
        <summary-block :site_id="site_id" range="Yesterday"></summary-block>
    </div>
    <div class="col-6 col-md-2">
        <summary-block :site_id="site_id" range="This week"></summary-block>
    </div>
    <div class="col-6 col-md-2">
        <summary-block :site_id="site_id" range="Last week"></summary-block>
    </div>
    <div class="col-6 col-md-2">
        <summary-block :site_id="site_id" range="This month"></summary-block>
    </div>
    <div class="col-6 col-md-2">
        <summary-block :site_id="site_id" range="Last month"></summary-block>
    </div>
</div>
</template> 

<script>
export default {
  props: ['site_id'],
}
</script>